module.exports = { "default": require("core-js/library/fn/math/tanh"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// ./~/babel-runtime/core-js/math/tanh.js
// module id = 1439
// module chunks = 0